/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import _truncate from 'lodash/truncate';
import Spinner from './Spinner';
import { formatBytes } from '../../common/formatBytes';
import * as Styled from './styles';

interface Props {
    file: File;
    errorMessage: string;
    isUploading: boolean;
}
/** The status line of an individual file upload, showing upload status and errors */
const FileStatus: FC<Props> = ({ file, errorMessage, isUploading }) => {
    const { name, size } = file;
    const statusText = errorMessage || (isUploading ? 'Scanning and uploading...' : '');
    const Icon = isUploading ? (
        <Spinner size="small" />
    ) : errorMessage ? (
        <Styled.SmallErrorIcon icon="exclamation-triangle" />
    ) : (
        <Styled.CheckIcon icon="check-circle" />
    );
    return (
        <Styled.FileStatusContainer isError={!!errorMessage}>
            <Styled.FlexDiv>
                {Icon}
                <Styled.FileName>{_truncate(name, { length: 30 })}</Styled.FileName>
            </Styled.FlexDiv>
            <Styled.FlexDiv>
                <Styled.FileStatusText isError={!!errorMessage}>{statusText}</Styled.FileStatusText>
                <Styled.FileSizeText>{formatBytes(size)}</Styled.FileSizeText>
            </Styled.FlexDiv>
        </Styled.FileStatusContainer>
    );
};

export default FileStatus;
